import { getUrlParam } from '@/utils';
import { mapState } from 'vuex';
let visitlogMixin = {
  ...mapState('global', ['env']),
  methods: {
    /**
     *
     * @param {string} module_name 模块名称
     * @param {boolean} isInvited 是否受邀者页面
     */
    trackLog(module_name = '', isInvited = false, actEvents = {}) {
      let invitation_code =
        getUrlParam('invitationCode') || this.$route.query.invitationCode;
      let activity_id = getUrlParam('code');
      console.log(this.env, 'env+++++++');
      let role_name = this.env == 'user' ? '用户' : '司机';
      this.visitLog(null, null, {
        module_name,
        role_name,
        activity_id,
        ...(isInvited ? { invitation_code } : {}),
        ...actEvents
      });
    }
  }
};

export default Vue => {
  Vue.mixin(visitlogMixin);
};
